import { useProfilePreviewData } from "PFApp/use_profile_preview";
import { Avatar } from "PFComponents/avatar";
import ProfileCardTitle from "PFComponents/profile_card/parts/profile_card_title";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useNavigate } from "react-router";

import css from "./profile_preview_basic_info.module.scss";

const ProfilePreviewBasicInfo = () => {
  const {
    data: { profile }
  } = useProfilePreviewData();
  const {
    data: { custom_types: customTypes }
  } = useMyAccountInfo();

  const navigate = useNavigate();

  const handleClick = () => {
    if (profile && profile.viewable) {
      navigate(`/profiles/${profile.id}`);
    }
  };

  return (
    <div className={css.root} data-qa-id="ProfilePreviewBasicInfo">
      {profile ? (
        <ProfileCardTitle
          avatarSize={90}
          customTypes={customTypes}
          handleClick={handleClick}
          href={profile.viewable ? `/profiles/${profile.id}` : undefined}
          onAvatarClick={handleClick}
          profile={profile}
        />
      ) : (
        <div className={css.avatar}>
          <Avatar size={90} text="?" />
        </div>
      )}
    </div>
  );
};

export default ProfilePreviewBasicInfo;
